import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import UserAvatar from 'components/shared/user/UserAvatar';
import StyledNotificationBody from 'common/theme/notification/StyledNotificationBody';
import StyledNotificationDate from 'common/theme/notification/StyledNotificationDate';
import StyledNotificationIconChip from 'common/theme/notification/StyledNotificationIconChip';
import StyledNotificationTitle from 'common/theme/notification/StyledNotificationTitle';
import { notificationTone } from 'common/utils/notificationTone';

/**
 * Anatomía ÚNICA de una notificación (campana y centro de notificaciones): chip a la
 * izquierda, título en una línea, cuerpo en dos y el tiempo relativo debajo.
 *
 * El punto de "no leída" y la X de borrar NO viven aquí: son cromo de la fila y los pone
 * el contenedor, que es quien sabe si la notificación está leída o caducada.
 */
function NotificationRowContent({ notification, title, body = null, icon = null, user = null }) {
  const IconComponent = icon;
  // El tono se deriva del tipo aquí (no lo pasa cada componente de notificación) para que
  // ninguna fila se quede sin color al añadir un tipo nuevo.
  const tone = notificationTone(notification.type);

  return (
    <Stack direction="row" spacing={1.5} sx={{ minWidth: 0, width: '100%' }}>
      <StyledNotificationIconChip tone={user ? 'neutral' : tone}>
        {user ? <UserAvatar size={34} textSize={13} user={user} /> : null}
        {!user && IconComponent ? <IconComponent sx={{ fontSize: 18 }} /> : null}
      </StyledNotificationIconChip>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <StyledNotificationTitle variant="body2">{title}</StyledNotificationTitle>
        {body ? <StyledNotificationBody variant="body2">{body}</StyledNotificationBody> : null}
        <StyledNotificationDate variant="caption" component="span">
          {notification.created_at}
        </StyledNotificationDate>
      </Box>
    </Stack>
  );
}

NotificationRowContent.propTypes = {
  body: PropTypes.node,
  icon: PropTypes.elementType,
  notification: PropTypes.shape({
    created_at: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  title: PropTypes.node.isRequired,
  user: PropTypes.object
};

export default NotificationRowContent;
